

import { BasicClientCommand } from "../BasicClientCommand";

export class PrivateOfferFinishDialogClientCommand extends BasicClientCommand {
    public execute(commandVars: any = null): void {
        return;
    }
}

